import { Col, Container, Row } from "../../components";
import { useContextHook } from "../../Context/ContextOPen";
import { servicesList } from "../../Context/Lists";
import { content } from "../../lang/useLang";

const Services = () => {
  const { swiperIndex, direction, setSwiperIndex } = useContextHook();

  return (
    <div
      className="min-h-screen py-5  bg-gradient-to-br from-[#081C29] via-[#0a2638] to-[#0d3045] relative overflow-hidden"
      style={{ direction }}
    >
      <br />
      {/* خلفية متحركة - تظهر فقط في الشريحة النشطة */}
      {swiperIndex === 3 && (
        <>
          <div className="absolute inset-0 overflow-hidden opacity-15">
            <div className="absolute -top-1/2 -left-1/2 w-full h-full bg-gradient-to-r from-cyan-500/20 to-blue-500/20 rounded-full animate-pulse-slow"></div>
            <div className="absolute -bottom-1/2 -right-1/2 w-full h-full bg-gradient-to-r from-purple-500/20 to-pink-500/20 rounded-full animate-pulse-slow animation-delay-2000"></div>
          </div>

          {/* جسيمات متحركة في الخلفية */}
          <div className="absolute inset-0 opacity-30">
            {[...Array(15)].map((_, i) => (
              <div
                key={i}
                className="absolute w-2 h-2 bg-cyan-400 rounded-full animate-float"
                style={{
                  left: `${Math.random() * 100}%`,
                  top: `${Math.random() * 100}%`,
                  animationDelay: `${Math.random() * 5}s`,
                  animationDuration: `${15 + Math.random() * 10}s`,
                }}
              ></div>
            ))}
          </div>
        </>
      )}

      <Container className="relative z-10">
        {/* العنوان مع أنيميشن - يظهر عند الوصول للشريحة */}
        <div
          className={`text-center mb-8 transition-all duration-1000 delay-300 ${
            swiperIndex === 3
              ? "opacity-100 translate-y-0"
              : "opacity-0 translate-y-10"
          }`}
        >
          <h1
            className="text-4xl md:text-5xl font-bold mb-4 logo"
            style={{
              background:
                "linear-gradient(135deg, #38bdf8 0%, #3b82f6 50%, #6366f1 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
            }}
          >
            {content.services}
          </h1>
          <div className="w-24 h-1 bg-gradient-to-r from-cyan-400 to-blue-500 mx-auto rounded-full mb-4"></div>
          <p className="text-gray-300 max-w-2xl mx-auto text-lg">
            {content["desc_services"]}
          </p>
        </div>

        {/* عرض الخدمات */}
        <Row className="">
          {servicesList.map((item, i) => (
            <Col md={6} lg={3} key={i} className=" group">
              {/* البطاقة مع أنيميشن متتالية */}
              <div
                onClick={() => {
                  setSwiperIndex(5);
                }}
                className={`relative h-full transform transition-all duration-1000 ${
                  swiperIndex === 3
                    ? "opacity-100 translate-y-0"
                    : "opacity-0 translate-y-10"
                }`}
                style={{
                  transitionDelay: `${i * 200 + 500}ms`,
                }}
              >
                {/* تأثير خلفي للبطاقة */}
                <div className="absolute -inset-1 bg-gradient-to-r from-cyan-500 via-blue-500 to-purple-500 rounded-2xl blur opacity-30 group-hover:opacity-70 transition duration-1000 group-hover:duration-200"></div>

                {/* البطاقة الرئيسية */}
                <div className="relative bg-gradient-to-br from-white to-gray-50 rounded-xl  shadow-2xl hover:shadow-2xl transition-all duration-500 group-hover:-translate-y-2 border border-white/20 flex flex-col items-center text-center h-full">
                  {/* أيقونة الخدمة */}
                  <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 z-10">
                    <div className="w-10 h-10 rounded-full bg-gradient-to-r from-cyan-500 to-blue-500 flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                      <span className="text-white font-bold text-sm">
                        {i + 1}
                      </span>
                    </div>
                  </div>

                  {/* صورة الخدمة */}
                  <div className="relative w-full h-48 overflow-hidden rounded-xl ">
                    <img
                      src={item.image}
                      alt={content["services_" + (i + 1)]}
                      className="w-full h-full object-cover transition-all duration-700 group-hover:scale-110 "
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-60 group-hover:opacity-30 transition-all duration-500"></div>

                    {/* تأثير فوق الصورة */}
                    <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/20 to-blue-500/20 opacity-0 group-hover:opacity-100 transition-all duration-700"></div>
                  </div>

                  {/* النص */}
                  <div className="p-5 flex flex-col items-center flex-grow w-full">
                    <h3 className="text-lg font-bold text-gray-800 group-hover:text-transparent group-hover:bg-clip-text group-hover:bg-gradient-to-r group-hover:from-cyan-600 group-hover:to-blue-600 transition-all duration-500 mb-3">
                      {content["services_" + (i + 1)]}
                    </h3>
                    <p className="text-gray-600 text-sm leading-relaxed flex-grow">
                      {content["desc_services_" + (i + 1)] ||
                        "نقدم خدمة متكاملة تلبي جميع احتياجاتكم بأعلى معايير الجودة والاحترافية، مع فريق عمل متخصص."}
                    </p>

                    {/* زر التفاصيل */}
                    <button
                      style={{ direction: direction }}
                      className="mt-4 px-4 py-2 bg-gradient-to-r from-cyan-500 to-blue-500 text-white rounded-full text-xs font-medium shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-300 group-hover:from-cyan-600 group-hover:to-blue-600 flex items-center"
                    >
                      {content["more"]}
                      <span className="inline-block mr-1 transform group-hover:translate-x-1 transition-transform duration-300">
                        ←
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>

      {/* إضافة الأنيميشن المخصصة في CSS */}
      {swiperIndex === 3 && (
        <style jsx>{`
          @keyframes pulse-slow {
            0%,
            100% {
              opacity: 0.3;
              transform: scale(1);
            }
            50% {
              opacity: 0.6;
              transform: scale(1.1);
            }
          }
          @keyframes float {
            0%,
            100% {
              transform: translateY(0) rotate(0deg);
              opacity: 0.7;
            }
            33% {
              transform: translateY(-20px) rotate(120deg);
              opacity: 1;
            }
            66% {
              transform: translateY(10px) rotate(240deg);
              opacity: 0.5;
            }
          }
          .animate-pulse-slow {
            animation: pulse-slow 8s ease-in-out infinite;
          }
          .animate-float {
            animation: float 20s ease-in-out infinite;
          }
          .animation-delay-2000 {
            animation-delay: 2s;
          }
        `}</style>
      )}
    </div>
  );
};

export default Services;
